export interface Category {
  id: string;
  name: string;
  slug: string;
  description: string;
  icon: string;
  articleCount: number;
  image: string;
}

export const categories: Category[] = [
  {
    id: 'cat-1',
    name: '青春期知识',
    slug: 'puberty',
    description: '系统讲解青春期身体变化、生理发育规律，帮助青少年科学认识自己的身体，消除困惑与焦虑。',
    icon: 'ri-user-heart-line',
    articleCount: 24,
    image: 'https://readdy.ai/api/search-image?query=Warm%20illustration%20of%20teenagers%20learning%20together%20in%20a%20bright%20modern%20classroom%20with%20soft%20natural%20lighting%2C%20educational%20posters%20on%20walls%2C%20gentle%20pastel%20color%20palette%2C%20calm%20and%20supportive%20atmosphere%2C%20editorial%20style%20photography&width=800&height=500&seq=cat-puberty-01&orientation=landscape'
  },
  {
    id: 'cat-2',
    name: '自我保护',
    slug: 'self-protection',
    description: '培养青少年自我保护意识和能力，学会识别危险信号、建立身体边界、掌握求助渠道与方法。',
    icon: 'ri-shield-check-line',
    articleCount: 18,
    image: 'https://readdy.ai/api/search-image?query=Gentle%20illustration%20of%20a%20teenager%20standing%20confidently%20with%20protective%20hand%20gesture%2C%20soft%20warm%20lighting%2C%20supportive%20environment%2C%20clean%20minimalist%20background%20with%20warm%20beige%20and%20cream%20tones%2C%20editorial%20photography%20style&width=800&height=500&seq=cat-protection-01&orientation=landscape'
  },
  {
    id: 'cat-3',
    name: '心理健康',
    slug: 'mental-health',
    description: '关注青少年心理与情感发展，帮助建立健康的自我认同、情绪管理能力与积极的人际关系。',
    icon: 'ri-mental-health-line',
    articleCount: 21,
    image: 'https://readdy.ai/api/search-image?query=Warm%20serene%20illustration%20of%20a%20teenager%20meditating%20peacefully%20in%20a%20sunlit%20room%20with%20plants%2C%20soft%20warm%20natural%20light%2C%20calm%20and%20soothing%20atmosphere%2C%20minimalist%20interior%20design%2C%20editorial%20photography%20with%20gentle%20tones&width=800&height=500&seq=cat-mental-01&orientation=landscape'
  },
  {
    id: 'cat-4',
    name: '家庭教育',
    slug: 'family-education',
    description: '为家长提供科学的家庭性教育指导，帮助父母与孩子建立良好的沟通渠道，共同面对成长话题。',
    icon: 'ri-home-heart-line',
    articleCount: 16,
    image: 'https://readdy.ai/api/search-image?query=Warm%20illustration%20of%20a%20parent%20and%20teenager%20having%20a%20gentle%20conversation%20on%20a%20cozy%20sofa%2C%20soft%20natural%20light%20from%20window%2C%20warm%20home%20atmosphere%2C%20supportive%20and%20loving%20scene%2C%20editorial%20photography%20style&width=800&height=500&seq=cat-family-01&orientation=landscape'
  },
  {
    id: 'cat-5',
    name: '性别平等',
    slug: 'gender-equality',
    description: '传递性别平等观念，打破性别刻板印象，帮助青少年建立尊重多元、包容差异的健康性别意识。',
    icon: 'ri-scales-line',
    articleCount: 14,
    image: 'https://readdy.ai/api/search-image?query=Inclusive%20illustration%20of%20diverse%20teenagers%20working%20together%20collaboratively%20in%20a%20bright%20modern%20space%2C%20equal%20participation%2C%20warm%20and%20welcoming%20atmosphere%2C%20clean%20minimalist%20design%2C%20editorial%20photography%20with%20soft%20lighting&width=800&height=500&seq=cat-gender-01&orientation=landscape'
  },
];

export const getCategoryBySlug = (slug: string): Category | undefined => {
  return categories.find((cat) => cat.slug === slug);
};